import React from "react";
import { Avatar } from "@fluentui/react-components";

const SearchedResource = (props) => {
  const { item, isActive, onSelect } = props;
  console.log(isActive, item.id);
  return (
    <div
      className={`userChip cursor-pointer ${isActive ? "active" : ""}`}
      onClick={onSelect}
    >
      <Avatar color="colorful" name={item.fullName} image={{ src: "" }} />
      <p className="text-xsm-400">{item.fullName}</p>
    </div>
  );
};

export default SearchedResource;
